import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ConfigService} from "../config/config.service";
import {ProAreaVariavel} from "../types/ProAreaVariavel.type";

@Injectable({
  providedIn: 'root'
})
export class ProintegracaoService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  sincronizarCadastros() {
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/proanalise/integracoes/sincronizar-cadastros`, "");
  }
}
